// Keep the original artwork and aspect ratio. Select a lossless, appropriately
// sized delivery copy rather than downloading the full logo on every page.
export function BrandLogo({ alt, className, sizes = "145px" }) {
  return <img alt={alt} className={className} width="952" height="420"
    src="/assets/img/logo-476-20261016.webp"
    srcSet="/assets/img/logo-238-20261016.webp 238w, /assets/img/logo-476-20261016.webp 476w, /assets/img/logo-lossless-20261016.webp 952w"
    sizes={sizes} decoding="async" />;
}
